import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { setAxiosAuth } from 'utils';
import { assetsApi } from 'core/api/assets.api';

export interface UseGetPortalInfoType {
  equipmentId?: string;
  accessToken?: string;
}

export const useGetEquipmentInfo = ({ equipmentId, accessToken = '' }: UseGetPortalInfoType) => {
  setAxiosAuth(accessToken);

  return useQuery({
    queryKey: [queryKeys.equipmentInfo, equipmentId],
    queryFn: async () => await assetsApi.getAssetDetail(equipmentId),
    staleTime: 1000 * 60 * 5,
    enabled: Boolean(accessToken && equipmentId),
  });
}
